import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useControlledState } from "@react-stately/utils";
/**
 * Provides state management for a checkbox group component. Provides a name for the group,
 * and manages selection and focus state.
 */

export function useCheckboxGroupState(props) {
  if (props === void 0) {
    props = {};
  }

  var _useControlledState = useControlledState(props.value, props.defaultValue || [], props.onChange),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      selectedValues = _useControlledState2[0],
      _setValue = _useControlledState2[1];

  var state = {
    value: selectedValues,
    setValue: function setValue(value) {
      if (props.isReadOnly || props.isDisabled) {
        return;
      }

      _setValue(value);
    },
    isDisabled: props.isDisabled || false,
    isReadOnly: props.isReadOnly || false,
    isSelected: function isSelected(value) {
      return selectedValues.includes(value);
    },
    addValue: function addValue(value) {
      if (props.isReadOnly || props.isDisabled) {
        return;
      }

      _setValue(function (values) {
        if (!values.includes(value)) {
          return values.concat(value);
        }

        return values;
      });
    },
    removeValue: function removeValue(value) {
      if (props.isReadOnly || props.isDisabled) {
        return;
      }

      _setValue(function (values) {
        if (values.includes(value)) {
          return values.filter(function (existingValue) {
            return existingValue !== value;
          });
        }

        return values;
      });
    },
    toggleValue: function toggleValue(value) {
      if (props.isReadOnly || props.isDisabled) {
        return;
      }

      _setValue(function (values) {
        if (values.includes(value)) {
          return values.filter(function (existingValue) {
            return existingValue !== value;
          });
        }

        return values.concat(value);
      });
    }
  };
  return state;
}